import { User } from '@queries/generated';
import * as sort from '@util/sort';
import { SelectItem } from 'primeng/api';

interface Input {
  id?: number;
  gid?: string;
  name?: string;
}

const idValue = (value: Input): number => {
  return value.id;
};

const gidValue = (value: Input): string => {
  return value.gid;
};

export function formatOptions(values: Input[], gid?: boolean): SelectItem[] {
  const fn = gid ? gidValue : idValue;
  if (values) {
    return values.map((value) => ({
      label: value.name,
      value: fn(value)
    }));
  }
  return [];
}

export function instructorOptions(values: Pick<User, 'firstName' | 'lastName' | 'gid'>[]): SelectItem[] {
  if (values) {
    return values
      .map((value) => ({
        label: `${value.firstName} ${value.lastName}`,
        data: value,
        value: value.gid
      }))
      .sort(sort.ByString('label'));
  }
  return [];
}
